// What the Follow-up tab shows for a quote's follow-up state, and which buttons it offers.

export const STATE_LABELS = {
  ENROLLED: 'Enrolled, waiting for approval',
  ACTIVE: 'Sending',
  AWAITING_REPLY: 'All steps sent, waiting for a reply',
  ESCALATED: 'Escalated (no reply)',
  REPLIED: 'Customer replied',
  STOPPED: 'Stopped',
  ERROR: 'Error, not sending'
}

export function stateLabel(state) {
  if (!state) return 'Not enrolled'
  return STATE_LABELS[state] || state
}

export function stopReasonLabel(reason) {
  if (!reason) return ''
  if (reason === 'MANUAL') return 'Stopped by hand'
  if (reason === 'REVISED') return 'The quote was revised; the new version has its own follow-up'
  if (reason.indexOf('STATUS_') === 0) return 'The quote status changed to ' + reason.slice(7)
  return reason
}

export const ACTION_LABELS = {
  enrol: 'Enrol',
  approve: 'Approve',
  stop: 'Stop',
  reenable: 'Re-enable',
  clearAttention: 'Clear attention',
  resolveSent: 'It was sent',
  resolveResend: 'Send it again'
}

function hasUncertain(followup) {
  return !!followup && followup.uncertainStepNo !== null && followup.uncertainStepNo !== undefined
}

/** Which email of unknown outcome, in words: "step 2", or the escalation email (step 0 / -1). */
export function uncertainEmail(stepNo) {
  var n = Number(stepNo)
  if (n === 0) return 'the escalation email to the salesperson'
  if (n === -1) return 'the escalation email to the customer'
  if (n === -2) return 'the approval email to the salesperson'
  return 'step ' + stepNo
}

export function uncertainWarning(stepNo) {
  return "We're not sure " + uncertainEmail(stepNo) + ' went — check the sent folder of the CRM mailbox'
}

/**
 * The buttons for a follow-up (null when the quote is not enrolled), in display order.
 * No buttons when the user may not act, or when there is no quote to enrol.
 * When the last email's outcome is unknown (`uncertainStepNo`), plain Re-enable is replaced by
 * "It was sent" / "Send it again" (the backend refuses a plain re-enable then).
 */
export function actionsFor(followup, canAct, hasQuote) {
  if (!canAct) return []
  if (!followup) return hasQuote === false ? [] : ['enrol']
  var out
  switch (followup.state) {
    case 'ENROLLED':
      out = ['approve', 'stop']
      break
    case 'ACTIVE':
    case 'AWAITING_REPLY':
    case 'ESCALATED':
      out = ['stop']
      break
    case 'STOPPED':
    case 'REPLIED':
      out = ['reenable']
      break
    case 'ERROR':
      // the backend lets an ERROR follow-up be re-enabled or stopped for good
      out = ['reenable', 'stop']
      break
    default:
      out = []
  }
  if (hasUncertain(followup) && (out.indexOf('reenable') >= 0)) {
    out = ['resolveSent', 'resolveResend'].concat(out.filter(function (a) { return a !== 'reenable' }))
  }
  if (followup.needsAttention) out.push('clearAttention')
  return out
}

// SENDING: the send was started and not yet confirmed. UNCERTAIN: it was started but whether the
// email went is not known (for example the server stopped mid-send), so someone should check the CRM
// mailbox's sent folder and answer "It was sent" or "Send it again".
export const LOG_STATUS_LABELS = {
  SENT: 'Sent',
  FAILED: 'Failed',
  SKIPPED: 'Not sent (sending is switched off)',
  SENDING: 'Sending…',
  UNCERTAIN: 'Unclear — check the sent folder'
}

export function logStatusLabel(status) {
  return LOG_STATUS_LABELS[status] || status
}

/** The backend logs escalations as step 0 (to the salesperson) and -1 (to the customer). */
export function logStepLabel(stepNo) {
  var n = Number(stepNo)
  if (n === 0) return 'Escalation (salesperson)'
  if (n === -1) return 'Escalation (customer)'
  if (n === -2) return 'Approval email (salesperson)'
  return 'Step ' + stepNo
}
